import { IUrl } from "../types/IUrl"

const urls: IUrl = {
    local: 'http://localhost:8080',
    development: 'http://system.wnmp.siegeventure.com',
    production: 'https://system.wnmp.eu'
};

export const url = urls.production;